import React, { useState } from "react";
import logo from "../../Assets/images/logo.svg";
import styles from "./Login.module.css";

// icons import
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { AuthService } from "../../service/auth_service";
import UnidadeSelectorModal from "../../components/UnidadeSelectorModal";
import { useUser } from "../../context/UserContext";

function Login() {
	const { refreshUser } = useUser();
	let [showPassword, setShowPassword] = useState(true);
	const [user, setUser] = useState("");
	const [senha, setSenha] = useState("");
	const [errorMsg, setErrorMsg] = useState("");
	const [carregandoLogin, setCarregandoLogin] = useState(false);
	const [showUnidadeModal, setShowUnidadeModal] = useState(false);

	function handleClick() {
		setShowPassword(!showPassword);
		if (showPassword) document.getElementById("password").type = "text";
		else document.getElementById("password").type = "password";
	}

	const confirm = async (e) => {
		setCarregandoLogin(true);
		e.preventDefault();

		const authService = new AuthService();

		try {
			await authService.authenticate(user.trim(), senha.trim());
			// Carrega o perfil no UserContext (em memória) antes de abrir o modal.
			await refreshUser();
			// Show modal to select unidade instead of directly redirecting
			setShowUnidadeModal(true);
		} catch (error){
			setErrorMsg(error.message);
		} finally {
			setCarregandoLogin(false);
		}
	};

	const handleUnidadeSelect = (unidade) => {
		// After unidade selection, redirect to home
		window.location.href = "/home";
	};

	return (
		<div className={styles.loginContainer}>
			<div className={styles.loginGrid}>
				{/* Left Side - Logo and Description */}
				<div className={styles.leftSide}>
					<div className={styles.logoSection}>
						<img className={styles.logo} src={logo} alt="Logo Sisagri" />
						<h2 className={styles.brandTitle}>Rastreabilidade Vegetal</h2>
						<h2 className={styles.brandTitle}>e Gestão agrícola</h2>
					</div>
				</div>

				{/* Right Side - Login Form */}
				<div className={styles.rightSide}>
					<div className={styles.formContainer}>
						<h2 className={styles.formTitle}>Acesse sua conta</h2>

						{errorMsg && <p className={styles.mensagemError}>{errorMsg}</p>}

						<div className={styles.inputGroup}>
							<label className={styles.label}>Usuário</label>
							<input
								className={styles.input}
								type="text"
								placeholder="Usuário"
								value={user}
								onChange={(e) => setUser(e.target.value)}
								onKeyUp={(e) => {
									if (e.key === "Enter" || e.keyCode === 13) {
										confirm(e);
									}
								}}
							/>
						</div>

						<div className={styles.inputGroup}>
							<label className={styles.label}>Senha</label>
							<div className={styles.passwordContainer}>
								<input
									id="password"
									className={styles.input}
									type={showPassword ? "password" : "text"}
									placeholder="Senha"
									value={senha}
									onChange={(e) => setSenha(e.target.value)}
									onKeyUp={(e) => {
										if (e.key === "Enter" || e.keyCode === 13) {
											confirm(e);
										}
									}}
								/>
								<div className={styles.eyeIcon} onClick={handleClick}>
									{showPassword ? (
										<VisibilityOffIcon sx={{ color: '#1a9e8f' }} />
									) : (
										<VisibilityIcon sx={{ color: '#1a9e8f' }} />
									)}
								</div>
							</div>
						</div>

						<div className={styles.checkboxContainer}>
							<input type="checkbox" id="remember" className={styles.checkbox} />
							<label htmlFor="remember" className={styles.checkboxLabel}>
								Mantenha-me conectado
							</label>
						</div>

						<button
							className={styles.buttonLogin}
							type="submit"
							onClick={confirm}
							disabled={carregandoLogin}
						>
							{carregandoLogin ? (
								<div className={styles.ldsroller}>
									<div></div>
									<div></div>
									<div></div>
									<div></div>
									<div></div>
									<div></div>
									<div></div>
									<div></div>
								</div>
							) : (
								<>
									Entrar
									<svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ marginLeft: '8px' }}>
										<path d="M7.5 15L12.5 10L7.5 5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
									</svg>
								</>
							)}
						</button>

						<div className={styles.recoveryLink}>
							<button
								type="button"
								onClick={() => alert('Funcionalidade em desenvolvimento')}
								className={styles.link}
								style={{ background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline' }}
							>
								Recuperar Senha
							</button>
						</div>
					</div>
				</div>
			</div>

			{/* Modal for selecting unidade distribuidora */}
			<UnidadeSelectorModal
				open={showUnidadeModal}
				onSelect={handleUnidadeSelect}
			/>
		</div>
	);
}

export default Login;
